<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>cdn项目管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = {};
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card
        class="box-card table"
        v-for="item in tableData"
        :label="item.id"
        :value="item.id"
        :key="item.id"
      >
        <div class="clearfix" slot="header">
          <a :href="'/vue/link?id=' + item.ID">
            <span>{{ item.Name }}</span>
            <el-button style="float: right; padding: 3px 0" type="text"
              >跳转链接</el-button
            >
          </a>
        </div>
        <div class="text">
          <div>
            <div class="right">
              <el-button type="primary" size="mini" @click="editClick(item)"
                >编辑</el-button
              >
              <el-button
                class="tagall"
                type="danger"
                size="mini"
                @click="copyAllLabel(item)"
                >全复制</el-button>
            </div>
            <div class="introl textcontent">{{ item.Summary }}</div>
          </div>
          <div class="linkcopy" v-if="item.lastVersion">
            <div
              v-for="item in item.lastVersion.UrlContent.split('\n')"
              :key="item"
              :value="item"
              :label="item"
            >
              <div class="right">
                <el-button
                  type="success"
                  size="mini"
                  v-clipboard:copy="item"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >复制链接</el-button
                >
                <el-button
                  class="tag"
                  type="warning"
                  size="mini"
                  @click="copyLabel(item)"
                  >复制标签</el-button
                >
              </div>
              <div class="introl">{{ item }}</div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </el-card>
      <div class="blank" v-if="tableData.length == 0">暂无数据~~</div>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑项目信息' : '添加项目信息'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="项目名称"
          prop="Name"
          :rules="[{ required: true, message: '请输入项目名称' }]"
        >
          <el-input v-model="form.Name" placeholder="请输入项目名称"></el-input>
        </el-form-item>

        <el-form-item label="展示地址" prop="SiteUrl">
          <el-input
            v-model="form.SiteUrl"
            placeholder="请输入展示地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="源码地址" prop="GitUrl">
          <el-input
            v-model="form.GitUrl"
            placeholder="请输入源码地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="项目简介" prop="Summary">
          <el-input
            v-model="form.Summary"
            placeholder="请输入项目简介"
          ></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="Sort">
          <el-input
            type="number"
            v-model.number="form.Sort"
            placeholder="请输入排序号"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      query: {}, //对象
      form: {}, //表单对象
      dialogVisible: false,
      dialogVersion: false,
      submiting: false,
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      labellist: [],
    };
  },
  methods: {
    //   列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var key = _this.query.key;
      var link = url.getCdn("getproject");
      $.get(link, { key: key }, (data) => {
        _this.loading = false;
        _this.tableData = data;
      });
    },
    // 查询
    selList: function () {
      this.getList();
    },
    // 编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 复制
    onCopy() {
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    onError() {
      this.$message.error("复制失败");
    },
    // 复制标签
    copyLabel: function (row) {
      if (row.match(/js$/)) {
        var link = '<script src="' + row + '"><' + "/script>";
      } else if (row.match(/css$/)) {
        var link = '<link href="' + row + '"  rel="stylesheet" />';
      }
      let clipboard = new Clipboard(".tag", {
        text: function () {
          return link;
        },
      });
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          showClose: true,
          type: "success",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message({ message: "复制失败,", showClose: true, type: "error" });
        clipboard.destroy();
      });
    },
    // 全复制
    copyAllLabel: function (row) {
      var _this = this;
      var array = row.lastVersion.UrlContent.split("\n");
      var link='';
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (item.match(/js$/)) {
          link +='<script src="' + item + '"><' + "/script>";
        } else if (item.match(/css$/)) {
          link +='<link href="' + item + '"  rel="stylesheet" />';
        }
        link+='\n';
      }
        let clipboard = new Clipboard(".tagall", {
          text: function () {
            return link;
          },
        });
        clipboard.on("success", (e) => {
          this.$message({
            message: "复制成功",
            showClose: true,
            type: "success",
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          this.$message({
            message: "复制失败,",
            showClose: true,
            type: "error",
          });
          clipboard.destroy();
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getCdn("saveproject");
      var info = this.form;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    // 列表
    this.getList();
  },
};
</script>